import script from "./ReferenceResources.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferenceResources.vue?vue&type=script&setup=true&lang=js"

import "./ReferenceResources.vue?vue&type=style&index=0&id=322370f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-322370f1"]])

export default __exports__